/**
 * Vuex module: preview mode state.
 *
 * Set by `plugins/preview.server.js` during SSR when a valid HMAC-signed
 * `?preview=<token>` query parameter is present on the incoming request.
 *
 * Consumed by:
 *   - Apollo Link chain (M2) to inject `status: DRAFT` and the Bearer token
 *   - Components/layout (M2) to render a "Preview mode" banner
 *   - Client navigation hook (M2) to force full-reload nav for re-validation
 */

export const state = () => ({
  isActive: false,
  uid: null,
  documentId: null,
  expiresAt: 0,
  token: null
})

export const mutations = {
  activate (state, { uid, documentId, expiresAt, token }) {
    state.isActive = true
    state.uid = uid
    state.documentId = documentId
    state.expiresAt = expiresAt
    state.token = token
  },
  deactivate (state) {
    state.isActive = false
    state.uid = null
    state.documentId = null
    state.expiresAt = 0
    state.token = null
  }
}

export const getters = {
  isPreview (state) {
    return state.isActive === true
  }
}
